import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import VerticalNameValue from '../../../components/library/layout/VerticalNameValue'
import HrbTranslate from '../../../components/language/HrbTranslate'
import T from 'i18n-react';
import EmdashText from '../../../components/library/common/EmdashText';
import InternalLink from '../../../router/InternalLink';

const PresaleInfo = (props) => {
    const { presale, lang} = props;

    const productName = T.translate(presale !== null ? presale.platform === null ? `ReturnInfo.ProductName.DIY.ONLINE.${lang}` : `ReturnInfo.ProductName.DIY.${presale.platform}.${lang}` : null)
    const pack = T.translate(presale !== null ? presale.platform === null ? `ReturnInfo.Package.ONLINE.TIER1.${lang}` : `ReturnInfo.Package.${presale.platform}.${presale.package}.${lang}` : null)
    const type = T.translate(presale !== null ? "ReturnInfo.Type." + presale.returnType + '.' + lang : null)

    const buildName = (firstName, lastName) => {
        if (!firstName) {
            return "-";
        }
        if (!lastName) {
            return firstName;
        }
        return `${firstName} ${lastName}`;
    }

    const primary = presale ? presale.associatedReturn ? buildName(presale.associatedReturn.primaryFirstName, presale.associatedReturn.primaryLastName) : null : null
    const spouse = presale && presale.associatedReturn && presale.associatedReturn.spouseFirstName ? buildName(presale.associatedReturn.spouseFirstName, presale.associatedReturn.spouseLastName) : null
    const associatedReturnLink = presale ? presale.associatedReturn ? '/returns/' + presale.associatedReturn.viewModelId + '/clients/' + presale.associatedReturn.userAccountId + '/year/' + presale.taxYear : '' : null   

    return (
        <Fragment>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="ReturnInfo.Labels.Product"
                        value={presale ? productName : null}
                        loading={!presale} />
                </div>  
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="ReturnInfo.Labels.Package"
                        value={presale ? pack : null}
                        loading={!presale} />
                </div>  
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="ReturnInfo.Labels.Type"
                        value={presale ? type : null}
                        loading={!presale} />
                </div>  
            </div>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="PresaleInfo.Labels.ActivationCode"
                        value={presale ? presale.couponCode : null}
                        loading={!presale} />
                </div>               
            </div>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <h5><HrbTranslate text='PresaleInfo.Labels.AssociatedReturn' /></h5>
                    <div>
                        {spouse ?
                            <InternalLink to={associatedReturnLink} useLinkBehavior>
                                <HrbTranslate text='ReturnInfo.NameFormatter.COUPLE' params={{ primary: primary, spouse: spouse }} />
                            </InternalLink> :
                            primary ?
                                <InternalLink to={associatedReturnLink} useLinkBehavior>
                                    <HrbTranslate text='ReturnInfo.NameFormatter.SINGLE' params={{ primary: primary }} />
                                </InternalLink> : <EmdashText />}                                       
                        </div>
                </div>
            </div>
        </Fragment>
    );
}

PresaleInfo.whyDidYouRender = false;

PresaleInfo.propTypes = {
    presale: PropTypes.object,
    lang: PropTypes.string
}

export default PresaleInfo